import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISiteIntervention } from '../entities/interventions/site-intervention.interface';
import { CrashlyticsService } from '../shared/crashlytics.service';
import { LoggingService } from '../shared/logging.service';
import { AbstractReadQueryService } from './abstract.read-query.service';
import { OfflineNotificationService } from './offline-notification.service';
import { ServerUrl } from './server-url.service';
import { UserEventWriteService } from './user-event.write.service';

@Injectable({ providedIn: 'root' })
export class SitesInterventionReadService extends AbstractReadQueryService<ISiteIntervention[]> {
  private readonly prefix: string = '/me/intervention';

  constructor(
    http: HttpClient,
    offlineService: OfflineNotificationService,
    userEventWriteService: UserEventWriteService,
    private readonly serverUrl: ServerUrl,
    log: LoggingService,
    crashlytics: CrashlyticsService
  ) {
    super(http, offlineService, userEventWriteService, log, crashlytics);
  }

  public hydrate(obj: any): ISiteIntervention[] {
    return obj;
  }

  public getResourceURL(urlParam: any = null): string {
    return this.serverUrl.get() + this.prefix;
  }
}
